import React from 'react';
import SimulatorsViewerArrangement from '../FullPagesComponents/SimulatorsViewerArrangement';
import SelectMethodFP from '../FullPagesComponents/Services/SelectMethodFP';

//= ========================================================================

const ChooseMethodDF = ({
  globJSON,
  simPlatform,
  slideshowRefs,
}) => (
  <SimulatorsViewerArrangement
    simPlatform={simPlatform}
  >
    <SelectMethodFP
      globJSON={globJSON}
      simPlatform={simPlatform}
      slideshowRefs={slideshowRefs}
    />
  </SimulatorsViewerArrangement>
);

export default ChooseMethodDF;
